import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { HomePage } from './pages/HomePage'

export const App = () => (
  <BrowserRouter>
    <HomePage />
  </BrowserRouter>
)
